

import React, { useState } from 'react';
import WeeklyShedule from './WeeklyShedule';
import BlackoutDates from './BlackoutDates';
import StripUnauthorised from '../../../../component/stripeUnauthorised';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';


const tabs = ['Weekly Shedule', 'Blackout Dates'];

const OperationalSetting = () => {
  const { isStripeAccount } = useSelector((state) => state.counter);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('Weekly Shedule');

  const renderContent = () => {
    switch (activeTab) {
      case 'Weekly Shedule':
        return <WeeklyShedule />;
      case 'Blackout Dates':
        return <BlackoutDates />;
      default:
        return null;
    }
  };

  return (
    <div className="pl-8 pr-6">

      <h2 className="text-2xl font-semibold mb-2 mt-1 ml-1">Operational Setting</h2>
      {!isStripeAccount && <StripUnauthorised handleBackProfile={() => navigate('/app/business/profile')} />}
      {isStripeAccount && (
        <div className='bg-[var(--primary-bg-color)] rounded-lg shadow px-2 pt-5 dark:border dark:border-[var(--table-border)]'>
          {/* Tab Header */}
          <div className="flex border-b mb-2">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-2 border-b-2 text-sm font-medium transition-all ${activeTab === tab
                  ? 'border-[#3587B8] text-[#3587B8]'
                  : 'border-transparent text-gray-500 hover:text-[#3587B8]'
                  }`}
              >
                {tab}
              </button>
            ))}
          </div>
          <div>
            {renderContent()}
          </div>
        </div>
      )}

    </div>
  );
};

export default OperationalSetting;
